import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { CommonService } from 'src/app/service/common.service';

declare var cv: any;

@Component({
  selector: 'app-barcode-scan-dialog',
  templateUrl: './barcode-scan-dialog.component.html',
  styleUrls: ['./barcode-scan-dialog.component.css']
})

export class BarcodeScanDialogComponent implements OnInit {

  public localStream: any;
  public decoding = false;
  public interval: any;
  public detector: any
  public barcodeList: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<BarcodeScanDialogComponent>,
    public commonService: CommonService,
  ) { }

  ngOnInit(): void {
    this.commonService.audioBeep = new Audio();
    this.commonService.audioBeep.src = "assets/audio/beep.mp3";
    this.commonService.audioBeep.load();
    this.openCvReady();
  }

  openCvReady() {
    this.startLiveScan();
    this.detector = new cv.barcode_BarcodeDetector();
    document.getElementsByClassName("camera")[0].addEventListener('loadeddata',() => {
      this.startDecodingLoop();
    }, false);
  }

  startLiveScan(){
    this.loadDevicesAndPlay();
  }

  loadDevicesAndPlay(){
    var constraints = {video: true, audio: false};
    navigator.mediaDevices.getUserMedia(constraints).then(stream => {
      this.localStream = stream;
      navigator.mediaDevices.enumerateDevices().then((devices) => {
        var count = 0;
        var cameraDevices = [];
        var defaultIndex = 0;
        for (var i = 0; i < devices.length; i++){
            var device = devices[i];
            if (device.kind == 'videoinput'){
                cameraDevices.push(device);
                var label = device.label || `Camera ${count++}`;
                if (label.toLowerCase().indexOf("front") != -1 || cameraDevices.length > 0) { //select the back camera as the default
                  defaultIndex = cameraDevices.length - 1;
                }
            }
        }
        if (cameraDevices.length > 0) {
          this.fnPlayVideo(cameraDevices[defaultIndex].deviceId);
        }else{
          alert("No camera detected.");
        }
      });
    });
  }

  fnPlayVideo(deviceId) {
    this.stopVideo(); // close before play
    var constraints = {};

    if (!!deviceId){
      constraints = {
        video: {deviceId: deviceId, zoom: true},
        audio: false
      }
    }else{
      constraints = {
        video: {zoom: true},
        audio: false,
      }
    }
    (<any> navigator.mediaDevices).getUserMedia(constraints).then((stream) => {
      this.localStream = stream;
      var cameraVideo = <HTMLVideoElement>document.getElementsByClassName("camera")[0];
      // Attach local stream to video element
      cameraVideo.srcObject = stream;

      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities();
      if (('zoom' in capabilities)) {
        let zoomVal = this.commonService.config.scanBarcode.zoom;
        if (zoomVal > 1.0) zoomVal = 0;
        zoomVal = Math.floor(capabilities.zoom.min + (capabilities.zoom.max - capabilities.zoom.min) * zoomVal);
        track.applyConstraints({ advanced: [{ zoom: zoomVal }] });
      } else {
        console.log('Zoom is not supported by ' + track.label);
      }
    }).catch(function(err) {
      console.error('getUserMediaError', err, err.stack);
      alert(err.message);
    });
  }

  stopVideo(){
    try{
      if (this.localStream){
        this.localStream.getTracks().forEach(track => track.stop());
      }
    } catch (e){
      alert(e.message);
    }
  }

  startDecodingLoop(){
    this.stopDecodingLoop();
    this.interval = setInterval(() => this.captureAndDecode(),this.commonService.config.scanBarcode.scanSpeed);
  }

  captureAndDecode(){
    if (this.decoding) {
      return;
    }
    if (!cv) {
      return;
    }
    this.decoding = true;
    try {
      this.capture();
      let cvs = document.getElementById("scanCanvas");
      let results = [];
      results = this.decodeWithOpenCV(cvs);
      if (results.length > 0) {
        try {
          this.onBeep();
          this.stopLiveScan();
          this.dialogRef.close(results[0]);
          setTimeout(() => {
            this.commonService.audioBeep.pause();
            this.commonService.audioBeep.currentTime = 0;
          }, 1000);
        } catch (e) {
          console.log('error: ', e)
        }
      }
    } catch (error) {}
    this.decoding = false;
  }

  capture() {
    let video = <HTMLVideoElement>document.getElementsByClassName("camera")[0];
    let canvas = <HTMLCanvasElement>document.getElementById("scanCanvas");
    let w = video.videoWidth;
    let h = video.videoHeight;
    canvas.width  = w;
    canvas.height = h;
    let ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, w, h);
  }

  stopDecodingLoop(){
    clearInterval(this.interval);
    this.decoding = false;
  }

  decodeWithOpenCV(imageSource) {
    let results = [];
    let mat = cv.imread(imageSource);
    let points = new cv.Mat();
    if(!this.detector) {
      this.detector = new cv.barcode_BarcodeDetector();
    }
    this.detector.detect(mat,points);
    let result = this.detector.decode(mat,points);
    mat.delete();
    points.delete();
    if (result && result.length >= this.commonService.config.scanBarcode.minCodeLength) {
      results.push(result);
      this.barcodeList.push(result);
      if (this.barcodeList.length > 1 && this.barcodeList[0] != this.barcodeList[1]) {
        this.barcodeList.shift();
      }
    }
    if(this.barcodeList.length == 2) return results;
  }

  stopLiveScan(){
    this.stopDecodingLoop();
    this.stopVideo();
  }

  onClose() {
    this.stopLiveScan();
    this.dialogRef.close();
  }

  onBeep() {
    this.commonService.audioBeep.pause();
    this.commonService.audioBeep.currentTime = 0;
    this.commonService.audioBeep.loop = false;
    this.commonService.audioBeep.play();
  }
}
